import { Flex, Paper } from "@pillar-ui/core";
import { Star } from "@pillar-ui/icons";
import colors from "../styles/colors";

const RatingStars = (props) => {
  const { value, onClick, onClickItem, size = "lg" } = props;
  let width = 20;
  let height = 20;
  if (size === "md") {
    width = 16;
    height = 16;
  } else if (size === "sm") {
    width = 12;
    height = 12;
  }

  return (
    <Paper
      {...(onClick
        ? {
            onClick,
            style: { cursor: "pointer" },
          }
        : {})}
    >
      <Flex items="center" gap="2">
        {Array.from({ length: 5 }).map((_item, index) => {
          const highlighted = index < value;
          return (
            <Paper
              key={`star_${index + 1}`}
              {...(onClickItem
                ? {
                    onClick: () => onClickItem(index + 1),
                    style: { cursor: "pointer" },
                  }
                : {})}
            >
              <Star
                key={`rating_star_${index + 1}`}
                color={colors.orange}
                width={width}
                height={height}
                strokeWidth={2}
                fill={highlighted ? colors.orange : "transparent"}
              />
            </Paper>
          );
        })}
      </Flex>
    </Paper>
  );
};

export default RatingStars;
